export default __webpack_public_path__ + "static/media/web.71f85bb3.png";